import { useEffect } from 'react';

/**
 * @param {string} href 链接
 */
export function useLink(href) {
  useEffect(() => {
    const link = document.createElement('link');

    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = href;
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);
}
